import React from "react";
import { Button } from "antd";
import { AppleFilled } from "@ant-design/icons";

interface SignInWithAppleProps {
    onClickCb: () => Promise<void>;
}

export default function SignInWithApple({ onClickCb }: SignInWithAppleProps) {
    return (
        <Button
            style={{
                color: "#FFFFFF",
                backgroundColor: "#000000",
                height: "44pt",
                width: "100%",
                fontSize: "14pt",
                borderRadius: "10px",
                borderColor: "#000000",
            }}
            onClick={() => onClickCb()}
        >
            <AppleFilled style={{ fontSize: "16pt" }} />
            <span style={{ marginLeft: "8pt", fontWeight: "bold" }}>Sign in with Apple</span>
        </Button>
    );
}
